import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {Tag} from 'folder-items/FileConstants';
import {BenchlingDispatch} from 'redux-stores/Store';
import SchemaTagInputs from 'schemas/tags/SchemaTagInputs';
import * as TagUtil from 'schemas/tags/TagUtil';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

import {REQUEST_TASK_SHAPE, ServerUIRequestTask, UIRequestTask} from './RequestTaskConstants';
import {createRequestTask} from './RequestTaskReduxActions';

export interface CreateRequestTaskModalProps {
  createRequestTask: (requestId: string, requestTask: ServerUIRequestTask) => Promise<void>;
  initialRequestTask: UIRequestTask;
  requestId: string;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

interface State {
  isSaving: boolean;
  requestTask: UIRequestTask;
}

class CreateRequestTaskModal extends React.Component<CreateRequestTaskModalProps, State> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    createRequestTask: PropTypes.func.isRequired,
    initialRequestTask: REQUEST_TASK_SHAPE.isRequired,
    requestId: PropTypes.string.isRequired,

    onRequestClose: PropTypes.func.isRequired,
    onRequestSubmit: PropTypes.func.isRequired,
  };

  state: State = {isSaving: false, requestTask: this.props.initialRequestTask};

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleSubmit = async () => {
    if (!TagUtil.areTagsValidAndNotify(this.state.requestTask.tags)) {
      return;
    }
    this.setState({isSaving: true});
    try {
      await this.props.createRequestTask(this.props.requestId, {
        ...this.state.requestTask,
        tags: TagUtil.getTagsToSet(this.state.requestTask.tags),
      });
      this.props.onRequestSubmit();
    } catch (e) {
      this.setState({isSaving: false});
      throw e;
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleUpdateTags = (newTags: Array<Tag>) => {
    this.setState({requestTask: {...this.state.requestTask, tags: newTags}});
  };

  render(): JSX.Element {
    return (
      <Modal
        title="Create task"
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            key: 'create',
            disabled: this.state.isSaving,
            onClick: this._handleSubmit,
            style: ButtonStyle.PRIMARY,
            submit: true,
            text: this.state.isSaving ? 'Creating...' : 'Create',
          },
        ]}
      >
        <SchemaTagInputs
          itemLinkAllowed={true}
          isCreating={true}
          isWritable={true}
          onUpdateTags={this._handleUpdateTags}
          tags={this.state.requestTask.tags}
        />
      </Modal>
    );
  }
}

function mapDispatchToProps(dispatch: BenchlingDispatch): {
  createRequestTask: (requestId: string, requestTask: ServerUIRequestTask) => void;
} {
  return {
    createRequestTask(requestId: string, requestTask: ServerUIRequestTask): void {
      // file is the JSON of a fileSummary that is surfaced from StandaloneDataTableAddSampleModal's search
      // component, which does not automatically get cached in a store, so we do that now manually.
      dispatch(createRequestTask(requestId, requestTask));
    },
  };
}

export default connect(null, mapDispatchToProps)(CreateRequestTaskModal) as React.ComponentType<
  Omit<CreateRequestTaskModalProps, 'createRequestTask'>
>;
